<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import moment from 'moment'
import { paymentService } from "../../../../services/reportservice/paymentservice.js";
import { servicehelpers } from "../../../../services/servicehelpers";


/* eslint-disable no-console */
export default {
  page: {
    title: "Unit Payment Detail Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
    Input
  },
  data() {
    return {
      title: "Unit Payment Detail Report",
      data: [],
      date: '',
      projects: {},
      groups: {},
      contractType:[
        {id: 1, label: 'បង់រំលស់'},
        {id: 2, label: 'បង់ជាដំណាក់'},
        {id: 3, label: 'បង់ផ្ដាច់'},
      ],
      paymentStatuss:[
        {id:1, label: "កំពុងបង់"},
        {id:2, label: "បានបង់រួច"},
      ],
      dataPaymentStatus: 0,
      projecttName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      user: JSON.parse(localStorage.getItem('user')),

      dataProjectId: 1,
      dataContractTypeId: 0,
      dataGroupId: 0,
      dataSearch: ''
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    this.loadingpropertyGroupData(this.dataProjectId);
    
  },
  methods: {
    
    loadingData: function() {
      this.fetchingStats = false;
      paymentService.getUnitPaymentDetail()
        .then(response => {
          this.fetchingStats = true;
          this.data = response.data.sale;
          this.date = response.data.date;
          this.projects = response.data.project;
          this.projectName = response.data.project_name;
          
        });
    },
    loadingpropertyGroupData: function(projectId = 1) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groups = response.data;
      });
    },
    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId+
        '&contract_type_id='+this.dataContractTypeId+
        '&group_id='+this.dataGroupId+
        '&payment_status_id='+this.dataPaymentStatus+
        '&data_search='+this.dataSearch;
      paymentService.getUnitPaymentDetail(data)
        .then(response => {
          this.data = response.data.sale;
          this.date = response.data.date;
          this.projects = response.data.project;
          this.projectName = response.data.project_name.name +'('+response.data.project_name.name_en+')';
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
      if(value == 0 ){
        return 0;
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    numberFormat(value) {
      if(!value){
        return '';
      }
      let sign = '';
      let decimal = '.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    numberFormat1(value) {
      if(!value){
        return '0';
      }
      let sign = '';
      let decimal = '';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },
    total(column_name) {
      return this.data.reduce(function (sum, item) {
        
        // if(column_name == 'discount'){
        //   let discount = (item.discount_type == 2) ? item[column_name] : ((item.price * item.discount) / 100);
        //   return sum + discount;
        // }
        if(column_name == 'without_interest'){
          let total = item.without_interest * item.no_interest_payment;
          return sum + total;
        }
        if(column_name == 'pendding_pricipal'){
          let total = item.sale_price - item.pay_first - item.paid_amount;
          return sum + total;
        }

        if(column_name == 'loan_month'){
          let total = item.loan_month - item.without_interest;
          return sum + total;
        }
        
        return sum + item[column_name];
        
      }, 0)
    },
  },

};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.text')+$t('report.payment.by-unit-detail')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              <div class="col-sm-2">
                <label>{{$t('general.search')}}</label>
                <Input 
                  :type="'text'"
                  :id="'data_search'"
                  :placeholder="$t('report.sale-detail.unit')+' / '+$t('customer.name')+' / '+$t('report.daily.phone')"
                  v-model="dataSearch"
                  @enter="submitSearch"
                /> 
              </div>
              <div class="col-sm-2">
                <label>{{$t('project.text')}}</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm">
                <label>{{$t('setting.configuration.contract-template.type')}}</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                   :list="{data: this.contractType}"
                  v-model="dataContractTypeId"
                /> 
              </div>
              <div class="col-sm">
                <label>{{$t('payment.status')}}</label>
                <Select
                  :id="'id'"
                  :text="'label'"
                  :editable="true"
                  :list="{data: this.paymentStatuss}"
                  v-model="dataPaymentStatus"
                /> 
              </div>
              <div class="col-sm">
                <label>{{$t('property.group')}}</label>
                <Select
                  :id="'id'"
                  :text="'name'"
                  :editable="true"
                  :list="{data: this.groups}"
                  v-model="dataGroupId"
                /> 
              </div>
              <div class="col-sm">
                <label class="text-white">{{$t('report.text')}}</label>
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div>
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="30%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <h4 class="khb"><u>{{$t('report.text')+$t('report.payment.by-unit-detail')}}</u></h4>
                    <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p>
                    <p class="khb"><u>កាលរិច្ឆេទ: {{this.dateFormat(date)}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
            
                <tr class="thead">
                  <th rowspan="2">{{$t('general.number')}}</th>
                  <th rowspan="2">{{$t('general.code')}}</th>
                  <th rowspan="2">{{$t('customer.type')}}</th>
                  <th rowspan="2">{{$t('customer.name')}}</th>
                  <th rowspan="2">{{$t('customer.phone-no')}}</th>
                  <th colspan="3">{{$t('property.text')}}</th>

                  <th rowspan="2">{{$t('sale.discount')}}</th>
                  <th rowspan="2">{{$t('sale.sale-price')}}</th>
                  <th rowspan="2">{{$t('report.sale-unit.pre-paid')}}</th>
                  <th rowspan="2">{{$t('payment.payment-method')}}</th>
                  <th colspan="2">{{$t('general.month_amount')}}</th>
                  <th colspan="1">{{$t('general.money')}}</th>

                  <th colspan="3">{{$t('general.total-paid-amount')}}</th>

                  <th colspan="3">{{$t('general.total-pending-amount')}}</th>
                  
                </tr>
                <tr class="thead">
                  <th rowspan="2">{{$t('general.code')}}</th>
                  <th rowspan="2">{{$t('report.sale-unit.unit-size')}}</th>
                  <th rowspan="2">{{$t('sale.price')}}</th>
                  <th>{{$t('report.sale-unit.total')}}</th>
                  <th>{{$t('general.paid')}}</th>
                  <th>{{$t('report.sale-unit.monthly-payment')}}</th>
                  <th>{{$t('general.amount')}}</th>
                  <th>{{$t('general.principal')}}</th>
                  <th>{{$t('general.interest')}}</th>
                  <th>{{$t('general.amount')}}</th>
                  <th>{{$t('general.principal')}}</th>
                  <th>{{$t('general.interest')}}</th>
                </tr>
              <tbody>
                <tr v-for="(list, index) in data" :key="index" >

                  <td>{{index + 1}}</td>
                  <td style="width:2cm;">{{list.customer_code}}</td>
                  <td>{{list.customer_type}}</td>
                  <td>{{list.customer_name}}</td>
                  <td>{{`${list.phone_no_1}` + (list.phone_no_2 !=null? ` / ${list.phone_no_2}` : '')}} </td>
                  
                  <td>{{list.property_code}}</td>
                  <td>{{numberFormat(list.net_size)}}M<sup style="font-size: 7px !important">2</sup></td>
                  <td>{{formatCurrency(list.price)}}</td>

                  <td>{{formatCurrency(list.discount)}}</td>
                  <td>{{formatCurrency(list.sale_price)}}</td>
                  <td>{{formatCurrency(list.pay_first)}}</td>
                  <td>{{list.loan_type_kh}}</td>

                  <td>{{list.loan_month}}</td>
                  <td>{{list.paid_month}}</td>

                  <td>{{formatCurrency(list.monthly_pay)}}</td>

                  <td>{{formatCurrency(list.paid_amount)}}</td>
                  <td>{{formatCurrency(list.paid_principal)}}</td>
                  <td>{{formatCurrency(list.paid_interest)}}</td>

                  <td>{{formatCurrency(list.unpaid_amount)}}</td>
                  <td>{{formatCurrency(list.unpaid_principal)}}</td>
                  <td>{{formatCurrency(list.unpaid_interest)}}</td>
                </tr>
              </tbody>
                <tr class="tfoot" v-if="data">
                  <td colspan="7" class="text-end pe-2">{{$t('report.total')}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('price'))}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('discount'))}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('sale_price'))}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('pay_first'))}}</td>
                  <td class="text-center border-start border-dark ps-2"></td>
                  <td class="text-center border-start border-dark ps-2"></td>
                  <td class="text-center border-start border-dark ps-2"></td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('monthly_pay'))}}</td>

                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('paid_amount'))}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('paid_principal'))}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('paid_interest'))}}</td>

                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('unpaid_amount'))}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('unpaid_principal'))}}</td>
                  <td class="text-center border-start border-dark ps-2">{{formatCurrency(total('unpaid_interest'))}}</td>
                </tr>
            </table>
            <br>
       
            <div class="row mt-3 report-table">
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>អគ្គនាយកក្រុមហ៊ុន</p>
                  <p class="mt-5">លី ប៊ុនហ៊ាង</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>នាយកហិរញ្ញវត្ថុ</p>
                  <p class="mt-5">លឹម ទ្រី</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>នាយកបច្ចេកទេស</p>
                  <p class="mt-5">សាយ នីយូស៊ន់</p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              <div class="col">
                <center>
                  <p class="mt-4">បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <p class="mt-5"></p>
                  <p>ថ្ងៃខែឆ្នាំ...........................</p>

                </center>
              </div>
              <div class="col">
                 <center>
                  <p>ថ្ងៃខែឆ្នាំ {{this.dateFormat(date)}}</p>
                  <p>ផ្នែកលក់</p>
                  <p class="mt-5">{{this.user.name}}</p>

                </center>
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>